export default __webpack_public_path__ + "static/media/logo.5ebe0f65.png";